export class LastSyncBigQueryDataWrapper {
    product: string;
    application: string;
    timestampDate: number;

    constructor(product: string,
                application: string,
                timestampDate: number) {
        this.product = product;
        this.application = application;
        this.timestampDate = timestampDate;
    }
}
